import React, { useEffect, useRef, useState } from 'react'
import './edit-table.scss'
import { Cancel, Close, Done, Edit } from '@mui/icons-material';
import { useClickAway } from 'react-use';
import textMk from 'js/textMk';



const Input = ({ open, name, ...props }) => {

    return <input {...props} name={name} />
}


const Tr = ({ columns, rowData }) => {

    const [open, setOpen] = useState(false)
    const [data, setData] = useState({})
    const rowRef = useRef()
    const onClose = () => {
        setOpen(false)
    }

    useClickAway(rowRef, onClose)

    useEffect(() => {
        if (open) {
            // const inp = document.getElementsByName(open)[0]
            // inp.focus()
            setData(rowData)
        }
    }, [open])

    const onChange = (e) => {
        let { name, value } = e.target
        setData({ ...data, [name]: value })
    }


    return <tr ref={rowRef} className={textMk(open ? "edit-row-active" : 'edit-row', "")}>
        {columns.map(col => {
            const { name, prefix } = col,
                value = open ? data[name] : rowData[name]

            const onEdit = () => setOpen(name)
            const onSave = () => {
                alert("Data Saved")
                setOpen('')
            }

            return <td className='edit-table-cell' onDoubleClick={onEdit} >
                {open && name ?
                    <input name={name} value={value} onChange={onChange} />
                    : <>
                        {prefix}{value}
                    </>}
            </td>
        })}
    </tr>
}


export default function EditTable({ columns = [], data = [], onChange }) {

    return (
        <div className='edit_table_container'>
            <div className='edit_table'>
                <table>
                    <tbody>
                        {/* Table Head */}
                        <tr>{columns.map(({ label }) => <td className='th'>{label}</td>)}</tr>
                        {/* Table Body */}
                        {data.map((d, i) => <Tr key={i} columns={columns} rowData={d} />)}
                    </tbody>
                </table>
                <br />
            </div>
        </div>
    )
}
